export const searchTerms = [
  'resource',
  'dmn',
  'business rule task',
  'decision'
].join(' ');
